
/**
 * Combines multiple class names into a single string, filtering out falsy values
 * @param classes Class names to combine
 * @returns A string of combined class names
 */
export const classNames = (...classes: (string | boolean | undefined | null)[]): string => {
  return classes.filter(Boolean).join(' ');
};

/**
 * Checks if the current user has a premium subscription
 * @returns Promise that resolves to a boolean indicating if the user is premium
 */
export const isPremiumUser = async (): Promise<boolean> => {
  try {
    // This is a placeholder function - in a real application,
    // you would check the user's subscription status from your database or auth provider
    const { supabase } = await import('@/integrations/supabase/client');
    const { data: { user } } = await supabase.auth.getUser();
    
    if (!user) return false;
    
    // Check if the user has a premium subscription by querying the profiles table
    const { data: profile } = await supabase
      .from('profiles')
      .select('subscription_plan')
      .eq('id', user.id)
      .single();
      
    return profile?.subscription_plan === 'Premium';
  } catch (error) {
    console.error("Error checking premium status:", error);
    return false;
  }
};
